import { useEffect, useState } from "react";
import { useCancelToken } from "./useCancelToken";
import { usersAPI } from "@/api";
import { getSeminarianDirections, ISeminarianDirection } from "@pages/Admin/Manage/tabs/GroupsPage/components/CreateGroupLinkModal/utils/api";

interface IUseGetUserProfileProps {
  userId?: string | number | null;
  expand?: string[];
  isGetSeminarianDirections?: boolean
}

interface IReturnUser extends IUser{
  seminarianDirections: ISeminarianDirection[]
}

interface IUseGetUserProfileReturn {
  profile: IReturnUser | null;
  loading: boolean;
  error: false | string
}

const DEFAULT_EXPAND: string[] = [];

export const useGetUserProfile = ({ 
  userId = null, 
  expand = DEFAULT_EXPAND,
  isGetSeminarianDirections = false
}: IUseGetUserProfileProps): IUseGetUserProfileReturn => {
  const [profile, setProfile] = useState<IReturnUser | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<false | string>(false);
  
  const { getCancelTokenSource } = useCancelToken();
  const { getCancelTokenSource: getCancelTokenSourceForDirection  } = useCancelToken();

  useEffect(() => {
    if (!userId) {
      setProfile(null);
      return;
    }

    const fetchUserProfile = async () => {
      setLoading(true);
      setError(false);
      
      const cancelTokenSource = getCancelTokenSource();
      try {
        const cancelTokenSourceForDirection = getCancelTokenSourceForDirection();

        const res: any = await usersAPI.getUser(
          { id: userId, expand },
          cancelTokenSource
        );
        
        if(isGetSeminarianDirections) {
          const seminarianDirections = await getSeminarianDirections(Number(userId), cancelTokenSourceForDirection)
          if(res?.status !== 200 || !seminarianDirections.success){
            setError('Ошибка получения пользователя');
            setProfile(null);
            setLoading(false);
            return;
          }

          setProfile({...res?.data, seminarianDirections:seminarianDirections.data });
        }
        else{
          if(res?.status !== 200){
            setError('Ошибка получения пользователя');
            setProfile(null);
            setLoading(false);
            return;
          }
          else{
            setProfile(res?.data);
          }
        }

      } 
      finally {
        setLoading(false);
      }
    };

    fetchUserProfile();
  }, [userId, expand]);

  return { profile, loading, error };
};